import { render } from "./userConfig.vue?vue&type=template&id=611dd4ba&scoped=true"
import script from "./userConfig.vue?vue&type=script&lang=js"
export * from "./userConfig.vue?vue&type=script&lang=js"

import "./userConfig.vue?vue&type=style&index=0&id=611dd4ba&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-611dd4ba"]])

export default __exports__